import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
function nodeStatusFor(room, bookings) {
    if (room.status === 'MAINTENANCE')
        return { status: 'maintenance' };
    if (room.status === 'CLOSED')
        return { status: 'closed' };
    const now = Date.now();
    const roomBookings = bookings.filter((b) => b.roomId === room.id && b.bookingStatus !== 'CANCELLED');
    const current = roomBookings.find((b) => {
        const start = new Date(b.startTime).getTime();
        const end = new Date(b.endTime).getTime();
        return start <= now && end > now && b.bookingStatus !== 'COMPLETED';
    });
    if (current)
        return { status: 'occupied', current };
    const recent = roomBookings
        .filter((b) => {
        const end = new Date(b.endTime).getTime();
        return end <= now && now - end < 60 * 60 * 1000;
    })
        .sort((a, b) => new Date(b.endTime).getTime() - new Date(a.endTime).getTime())[0];
    const upcoming = roomBookings
        .filter((b) => new Date(b.startTime).getTime() > now)
        .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())[0];
    if (recent)
        return { status: 'completed', current: recent, upcoming };
    return { status: 'idle', upcoming };
}
function fmtTimeShort(iso) {
    return new Date(iso).toLocaleTimeString('en-CA', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'America/Halifax',
    });
}
export function MCVenueView({ rooms, bookings, onSelectRoom }) {
    const sorted = [...rooms].sort((a, b) => a.name.localeCompare(b.name));
    return (_jsxs("div", { className: "relative w-full h-full flex items-center justify-center", children: [_jsxs("div", { className: "absolute inset-0 flex items-center justify-center pointer-events-none", children: [_jsx("div", { className: "rounded-full border opacity-20", style: {
                            width: 'min(80%, 520px)',
                            aspectRatio: '1',
                            borderColor: 'var(--mc-divider)',
                        } }), _jsx("div", { className: "absolute rounded-full border opacity-10", style: {
                            width: 'min(100%, 680px)',
                            aspectRatio: '1',
                            borderColor: 'var(--mc-divider)',
                        } })] }), _jsx("div", { className: "relative z-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8 p-8", children: sorted.map((room) => {
                    const { status, current, upcoming } = nodeStatusFor(room, bookings);
                    const nodeCls = status === 'occupied'
                        ? 'mc-node mc-node-occupied'
                        : status === 'completed'
                            ? 'mc-node mc-node-completed'
                            : status === 'maintenance'
                                ? 'mc-node mc-node-maintenance'
                                : 'mc-node';
                    return (_jsxs("button", { onClick: () => onSelectRoom?.(room.id), className: "flex flex-col items-center gap-3 group focus:outline-none", children: [_jsxs("div", { className: "relative", children: [status === 'occupied' && (_jsx("span", { className: "mc-pulse-ring", style: {
                                            boxShadow: '0 0 0 1px var(--mc-cyan)',
                                        } })), _jsxs("div", { className: nodeCls, children: [_jsx("span", { className: "text-sm font-medium tracking-wide", children: room.name }), status === 'occupied' && current && (_jsx("span", { className: "mc-mono text-[10px] text-[color:var(--mc-cyan)] mt-1", children: "LIVE" }))] })] }), _jsxs("div", { className: "text-center min-h-[2.5rem]", children: [status === 'occupied' && current && (_jsxs(_Fragment, { children: [_jsx("div", { className: "text-xs text-[color:var(--mc-white)] truncate max-w-[120px]", children: current.customerName }), _jsxs("div", { className: "mc-meta-dim mc-mono", children: ["until ", fmtTimeShort(current.endTime)] })] })), status === 'idle' && upcoming && (_jsxs(_Fragment, { children: [_jsx("div", { className: "mc-meta truncate max-w-[120px]", children: "next" }), _jsx("div", { className: "mc-meta-dim mc-mono", children: fmtTimeShort(upcoming.startTime) })] })), status === 'completed' && (_jsx("div", { className: "mc-meta-dim mc-mono", children: "just ended" })), status === 'maintenance' && (_jsx("div", { className: "mc-meta-dim", children: "maintenance" })), status === 'closed' && (_jsx("div", { className: "mc-meta-dim", children: "closed" })), status === 'idle' && !upcoming && (_jsx("div", { className: "mc-meta-dim", children: "available" }))] })] }, room.id));
                }) })] }));
}
